import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCampaign = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 16,
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 19 16",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		fillRule: "nonzero",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M17.5 11.733V3.2c0-.884-.672-1.6-1.5-1.6H4v-.533C4 .477 4.448 0 5 0h13c.552 0 1 .478 1 1.067v9.6c0 .589-.448 1.066-1 1.066h-.5z" }),
			/* @__PURE__ */ _jsx("path", { d: "M15.5 13.867V5.333c0-.883-.672-1.6-1.5-1.6H2V3.2c0-.59.448-1.067 1-1.067h13c.552 0 1 .478 1 1.067v9.6c0 .59-.448 1.067-1 1.067h-.5z" }),
			/* @__PURE__ */ _jsx("path", { d: "M13.594 4.267c.776 0 1.406.656 1.406 1.466v8.8c0 .81-.63 1.467-1.406 1.467H1.406C.63 16 0 15.343 0 14.533v-8.8c0-.81.63-1.466 1.406-1.466h12.188zm0 1.466H1.406V6.98c.657.558 1.705 1.426 3.943 3.254.493.405 1.471 1.377 2.151 1.366.68.011 1.657-.961 2.15-1.366a294.414 294.414 0 0 0 3.944-3.254V5.733zm-12.188 8.8h12.188v-5.67a501.49 501.49 0 0 1-3.075 2.525c-.66.542-1.768 1.686-3.019 1.679-1.258.007-2.38-1.154-3.02-1.68a503.33 503.33 0 0 1-3.074-2.525v5.671z" })
		]
	})
});
export default SvgIconCampaign;
